<template>
  <div>
    <!-- <left-menu-admin
      ref="modal"
      menuActive="0"
      :sessionData="session"
    ></left-menu-admin> -->
    <v-main>
      <div class="col-md-12 ml-sm-auto col-lg-12 px-4">
        <v-row>
          <v-col cols="6" class="text-left">
            <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
          </v-col>
          <v-col cols="6" class="v-margit_button text-right">
            <v-btn
              color="#1B437C"
              depressed
              dark
              @click="(dialogAdd = true), validate('ADD');"
            >
              <v-icon left>mdi-text-box-plus</v-icon>
              เพิ่ม
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <!-- ADD -->
          <v-dialog v-model="dialogAdd" persistent max-width="40%">
            <v-card class="text-center">
              <v-card-text>
                <v-container>
                  <v-col class="text-right">
                    <v-btn
                      small
                      color="#E0E0E0"
                      @click="(dialogAdd = false), clearData();"
                    >
                      <v-icon color="#173053">mdi-close</v-icon>
                    </v-btn>
                  </v-col>
                  <v-row class="mb-6" justify="center">
                    <v-col md="auto">
                      <v-img
                        class="v-img-margit"
                        :src="require('@/assets/qricon.png')"
                      ></v-img>
                    </v-col>
                  </v-row>
                  <v-row class="mb-6" justify="center">
                    <v-col md="auto">
                      <v-img
                        class="v_text_add"
                        :src="require('@/assets/Grouptitle.png')"
                      ></v-img>
                    </v-col>
                  </v-row>
                  <v-form ref="form_add" v-model="validAdd" lazy-validation>
                    <v-col cols="12">
                      <v-row style="height: 65px">
                        <v-select
                          v-model="formAdd.packageId"
                          :items="packageId"
                          dense
                          outlined
                          :rules="[rules.required]"
                          label="แพคเกจ"
                        ></v-select>
                      </v-row>
                    </v-col>
                    <!-- <v-col cols="12">
                      <v-row style="height: 65px">
                        <v-text-field
                          v-model="formAdd.chkQRCode"
                          dense
                          outlined
                          label="จำนวนที่สร้าง"
                        ></v-text-field>
                      </v-row>
                    </v-col> -->
                    <v-col cols="6">
                      <v-row style="height: 65px">
                        <v-select
                          v-model="formAdd.masBranchID"
                          :items="dataBranch"
                          label="สาขา"
                          dense
                          outlined
                          :rules="[rules.required]"
                        ></v-select>
                      </v-row>
                    </v-col>
                  </v-form>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-col id="margin">
                  <v-row justify="center">
                    <v-btn
                      elevation="2"
                      x-large
                      color="#173053"
                      dark
                      :disabled="!validAdd"
                      :loading="loadingAdd"
                      @click="addData()"
                    >
                      <v-icon left>mdi-checkbox-marked-circle</v-icon>
                      เพิ่ม
                    </v-btn>
                  </v-row>
                </v-col>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- end add -->

          <!-- QR Code -->
          <v-dialog v-model="dialogViewAdd" v-if="dialogViewAdd" persistent max-width="40%">
            <v-card>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col
                      cols="12"
                      class="text-center"
                      style="justify-content:center;display:flex"
                    >
                      <v-img
                        class="my-auto"
                        :src="session.data.logo"
                        max-width="80"
                      ></v-img>
                    </v-col>
                    <v-col
                      cols="12"
                      style="justify-content:center;display:flex"
                    >
                      <span class="my-auto shopname">{{
                        session.data.name
                      }}</span>
                    </v-col>
                    <!-- <v-col>
                      <v-row>
                        <v-col class="pt-3 pb-0"
                          ><span class="description" id="text_a"
                            >วันที่
                            {{
                              thaiFormattedDate(formUpdate.CREATE_DATE)
                            }}</span
                          ></v-col
                        >
                      </v-row>
                    </v-col> -->
                  </v-row>
                  <v-divider
                    color="#FFA000"
                    style="margin-bottom: 10px"
                  ></v-divider>
                  <v-row>
                    <v-col>
                      <p>
                        หมายเหตุ : QR CODE สามารถใช้ได้แค่ครั้งเดียวเท่านั้น
                      </p>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col class="text-center">
                      <!-- {{ formUpdate.qrCodeURL }} -->
                      <qrcode-vue
                        style="margin-top: 10px"
                        :value="formUpdate.qrCodeURL"
                        :size="size"
                        level="H"
                      ></qrcode-vue>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col class="pt-3 pb-0 text-center">
                      <h3>แพคเกจ {{ formUpdate.packageName }}</h3>
                      <!-- <span class="summary" id="text_a"
                        >แพคเกจ {{ formUpdate.packageName }}</span
                      > -->
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col class="pa-4 text-center">
                      <h3>จำนวน {{ formUpdate.packageCount }} ครั้ง</h3>
                      <!-- <span class="point s-4" id="text_b">

                        จำนวน {{ formUpdate.packageCount }} ครั้ง</span
                      > -->
                    </v-col>
                  </v-row>
                  <v-divider color="#C4C4C4"></v-divider>
                  <v-row>
                    <v-col class="pt-3 pb-0">
                      <span class="description" id="text_a">ราคาแพคเกจ: </span>
                    </v-col>
                    <v-col class="text-right">
                      <h2></h2>
                      <span class="description" id="text_a"
                        >{{ formatNumber(formUpdate.packagePrice) }} บาท</span
                      >
                    </v-col>
                  </v-row>
                  <v-row
                    style="margin-top: 1px"
                    v-if="formUpdate.packagePoint > 0"
                  >
                    <v-col class="text-right">
                      <span class="description" id="text_a"
                        >+ {{ formUpdate.packagePoint }} คะแนน</span
                      >
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  elevation="2"
                  x-large
                  dark
                  color="blue darken-1"
                  @click="
                    (dialogAdd = false),
                      (dialogViewAdd = false),
                      clearData(),
                      getDataGlobal(
                        DNS_IP,
                        path,
                        session.data.shopId + '&status=waiting'
                      ),
                      getPackage();
                  "
                >
                  <v-icon left> mdi-cancel</v-icon>
                  ปิด
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- end view -->

          <!-- view QR Code -->
          <v-dialog v-model="dialogView" v-if="dialogView" persistent max-width="40%">
            <v-card>
              <v-card-text>
                <v-container>
                  <v-col class="text-right">
                    <v-btn
                      small
                      color="#E0E0E0"
                      @click="
                        (dialogView = false),
                          getDataGlobal(
                            DNS_IP,
                            path,
                            session.data.shopId + '&status=waiting'
                          ),
                          getPackage();
                      "
                    >
                      <v-icon color="#173053">mdi-close</v-icon>
                    </v-btn>
                  </v-col>
                  <v-row>
                    <v-col class="text-center">
                      <v-img :src="session.data.logo" max-width="50"></v-img>
                      <span class="mr-16 shopname">{{
                        session.data.name
                      }}</span>
                    </v-col>
                    <v-col>
                      <v-row>
                        <v-col class="pt-3 pb-0"
                          ><span class="description" id="text_a"
                            >วันที่
                            {{ format_date(formUpdate.CREATE_DATE) }}</span
                          ></v-col
                        >
                      </v-row>
                    </v-col>
                  </v-row>
                  <v-divider
                    color="#FFA000"
                    style="margin-bottom: 10px"
                  ></v-divider>
                  <v-row>
                    <v-col class="text-center"
                      >{{ formUpdate.qrCodeURL }}
                      <qrcode-vue
                        style="margin-top: 50px"
                        :value="formUpdate.qrCodeURL"
                        :size="size"
                        level="L"
                      ></qrcode-vue>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col class="pt-3 pb-0 text-center"
                      ><span class="summary" id="text_a"
                        >แพคเกจ {{ formUpdate.packageName }}</span
                      ></v-col
                    >
                  </v-row>
                  <v-row>
                    <v-col class="pa-4 text-center"
                      ><span class="point s-4" id="text_b">
                        จำนวน {{ formUpdate.packageCount }} ครั้ง
                      </span></v-col
                    >
                  </v-row>
                  <v-divider color="#C4C4C4"></v-divider>
                  <v-row>
                    <v-col class="pt-3 pb-0">
                      <span class="description" id="text_a">ราคาแพคเกจ: </span>
                    </v-col>
                    <v-col class="text-right">
                      <span class="description" id="text_a"
                        >{{ formatNumber(formUpdate.packagePrice) }} บาท</span
                      >
                    </v-col>
                  </v-row>
                  <v-row
                    style="margin-top: 1px"
                    v-if="formUpdate.packagePoint > 0"
                  >
                    <v-col class="text-right">
                      <span class="description" id="text_a"
                        >{{ formUpdate.packagePoint }} คะแนน</span
                      >
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  elevation="2"
                  x-large
                  color="#173053"
                  dark
                  @click="
                    (dialogView = false),
                      getDataGlobal(
                        DNS_IP,
                        path,
                        session.data.shopId + '&status=waiting'
                      ),
                      getPackage();
                  "
                >
                  <v-icon left> mdi-cancel</v-icon>
                  ปิด
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- end view -->

          <!-- edit -->
          <v-dialog v-model="dialogEdit" persistent max-width="40%">
            <v-card class="text-center">
              <v-card-text>
                <v-container>
                  <v-col class="text-right">
                    <v-btn
                      small
                      color="#E0E0E0"
                      @click="
                        (dialogEdit = false),
                          getDataGlobal(
                            DNS_IP,
                            path,
                            session.data.shopId + '&status=waiting'
                          );
                      "
                    >
                      <v-icon color="#173053">mdi-close</v-icon>
                    </v-btn>
                  </v-col>
                  <v-row class="mb-6" justify="center">
                    <v-col md="auto">
                      <v-img
                        class="v_text_edit"
                        :src="require('@/assets/GroupEditTitle.svg')"
                      ></v-img>
                    </v-col>
                  </v-row>
                  <div class="text-center" style="margin-top: 15px">
                    <qrcode-vue
                      :value="formUpdate.qrCodeURL"
                      :size="size"
                      level="H"
                    ></qrcode-vue>
                  </div>
                  <v-form
                    ref="form_update"
                    v-model="validUpdate"
                    lazy-validation
                  >
                    <v-col cols="12">
                      <v-row style="height: 65px">
                        <v-select
                          v-model="formUpdate.packageId"
                          :items="packageId"
                          dense
                          outlined
                          :rules="[rules.required]"
                          label="แพคเกจ"
                        ></v-select>
                      </v-row>
                    </v-col>
                  </v-form>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-col id="margin">
                  <v-row justify="center">
                    <v-btn
                      elevation="2"
                      x-large
                      dark
                      color="#173053"
                      :disabled="!validUpdate"
                      :loading="loadingEdit"
                      @click="editData()"
                    >
                      <v-icon left>mdi-checkbox-marked-circle</v-icon>
                      บันทึก
                    </v-btn>
                  </v-row>
                </v-col>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- end edit -->

          <!-- delete -->
          <v-dialog v-model="dialogDelete" persistent max-width="40%">
            <v-card>
              <v-card-title>
                <span class="headline">ลบข้อมูลนี้</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        label="แพคเกจ"
                        v-model="formUpdate.packageName"
                        readonly
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  elevation="2"
                  x-large
                  dark
                  class="btn-color"
                  @click="dialogDelete = false"
                >
                  <v-icon left> mdi-cancel</v-icon>
                  ปิด
                </v-btn>
                <v-btn
                  elevation="2"
                  x-large
                  dark
                  color="red darken-1"
                  @click="deleteData()"
                >
                  <v-icon left>mdi-checkbox-marked-circle</v-icon>
                  ลบ
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- end delete -->

          <!-- view cf -->
          <v-dialog v-model="dailogViewRedeem" persistent max-width="400">
            <v-card>
              <v-container>
                <div v-if="!statusViewRedeem" @click="closeViewRedeem()" style="text-align: end;color: red;">ปิด</div>
                <v-card-title style="padding-bottom: 3px;">
                  <v-icon :color="statusViewRedeem ? 'green' : 'red'" class="mr-2">{{statusViewRedeem ? 'mdi-check-circle' : 'mdi-close-circle'}}</v-icon>ยืนยันการใช้แพคเกจ
                </v-card-title>
                <v-divider style="margin-top: 1rem !important;margin-bottom: 1rem !important;"></v-divider>
                <v-card-text v-if="!statusViewRedeem">
                  <v-alert dense outlined type="error">
                    <strong>ไม่พบข้อมูลแพคเกจ</strong>
                  </v-alert>
                </v-card-text>
                <div v-if="statusViewRedeem">
                  ข้อมูลลูกค้า
                  <div style="display:flex">
                    <div class="mr-4 pt-1"><v-avatar color="primary" size="60">
                      <img :src="formView.picture" alt="img"
                    /></v-avatar></div>
                    <div>
                      <div>รหัสสมาชิก: {{formView.memberId}}</div>
                      <div>ชื่อไลน์ลูกค้า: {{formView.name}}</div>
                      <div>ชื่อลูกค้า: {{formView.nameCustomer}}</div>
                    </div>
                  </div>
                </div>
                <v-divider style="margin-top: 1rem !important;margin-bottom: 1rem !important;"></v-divider>
                <v-card-text v-if="statusViewRedeem && loadingPacka === false">
                  <div class="mb-3">
                    <div cols="12" style="padding-top: 15px;">
                      <!-- <p class="mx-auto">ข้อมูลแพคเกจ</p> -->
                      <v-card-title style="justify-content: center !important" class="mb-3">{{ formView.packageName }}</v-card-title>
                      <v-img
                        class="mx-auto"
                        style="border-radius:10px"
                        :src="formView.packageImg"
                        max-width="170"
                      ></v-img>
                    </div>
                  </div>
                  <!-- <v-row>
                    <v-col cols="12">
                      <h3 class="text-center ">{{ formView.packageName }}</h3>
                    </v-col>
                  </v-row> -->
                  <div>
                    <div cols="12">
                      <h3 class="text-center ">
                        คงเหลือ {{ showDecimal(formView.balanceAmount) }}/{{
                          formView.amount
                        }}
                      </h3>
                    </div>
                  </div>
                  <v-text-field v-if="statusCheckBranch" :rules="[rules.moreThanZero]" outlined dense label="จำนวนที่ต้องการใช้" v-model="amountOf">
                  </v-text-field>
                  <div>
                    <v-alert v-if="!statusCheckBranch" outlined type="error" text border="left">
                      <p class="mb-2">สาขาที่สามารถใช้ได้</p>
                      <v-chip v-for="(item, i) in formView.useInBranch" :key="i">
                        {{item}}
                      </v-chip>
                    </v-alert>
                    <div class="text-center">
                      <v-btn
                        color="green"
                        style="color: white !important"
                        v-if="statusViewRedeem && statusCheckBranch"
                        type="number"
                        :disabled="!amountOf || parseFloat(amountOf) > parseFloat(formView.balanceAmount) || parseFloat(amountOf) === 0 || !statusCheckBranch"
                        @click="updateUsePackage()"
                        >ยืนยัน</v-btn
                      >
                      <v-btn
                        dark
                        color="red darken-1"
                        @click="closeViewRedeem()"
                        >ยกเลิก</v-btn
                      >
                    </div>
                  </div>
                </v-card-text>
                <v-card-text v-if="statusViewRedeem && loadingPacka === true" class="pa-5">
                  ระบบกำลังตัดแพ๊กเกจ รอสักครู่
                  <v-progress-circular
                    :size="20"
                    :width="7"
                    color="#203452"
                    indeterminate
                  ></v-progress-circular>
                </v-card-text>
              </v-container>
            </v-card>
            <!-- <v-card>
              <v-card-title>
                <span class="headline">ยืนยัน</span>
              </v-card-title>
              <v-card-text v-if="!statusViewRedeem">
                <v-alert dense outlined type="error">
                  <strong>Data not found</strong>
                </v-alert>
              </v-card-text>
              <v-card-text v-if="statusViewRedeem">
                <v-container>
                  <b>ข้อมูลแพคเกจ</b>
                  <v-row>
                    <v-col class="text-center">
                      <v-img :src="formView.packageImg" max-width="90"></v-img>
                    </v-col>
                    <v-col>
                      <v-row>
                        <v-col class="pt-3 pb-0"
                          ><span class="description"
                            ><b>แพคเกจ :</b> {{ formView.packageName }}</span
                          ></v-col
                        >
                      </v-row>
                      <v-row>
                        <v-col class="pt-0 pb-0"
                          ><span class="description">
                            จำนวนครั้ง : {{ formView.amount }}</span
                          ></v-col
                        >
                      </v-row>
                      <v-row>
                        <v-col class="pt-0 pb-0"
                          ><span class="description">
                            จำนวนที่เหลือ : {{ formView.balanceAmount }}</span
                          ></v-col
                        >
                      </v-row>
                    </v-col>
                  </v-row></v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  elevation="2"
                  x-large
                  dark
                  color="red darken-1"
                  @click="closeViewRedeem()"
                >
                  <v-icon left> mdi-cancel</v-icon>
                  ปิด
                </v-btn>
                <v-btn
                  elevation="2"
                  x-large
                  dark
                  color="green darken-1"
                  v-if="statusViewRedeem"
                  @click="updateUsePackage()"
                >
                  <v-icon left> mdi-content-save-all</v-icon>
                  ยืนยัน
                </v-btn>
              </v-card-actions>
            </v-card> -->
          </v-dialog>

          <!-- data table -->
          <v-col cols="12">
            <v-card elevation="7" v-if="dataReady">
              <v-card-title>
                <v-text-field
                  v-model="searchAll2"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                  dense
                ></v-text-field>
              </v-card-title>
              <v-card-text>
                <v-data-table
                  :headers="columns"
                  :items="dataItem"
                  :search="searchAll2"
                  :items-per-page="10"
                  dense
                >
                  <template v-slot:[`item.amount`]="{ item }">
                    {{ formatNumber(item.amount) }}
                  </template>
                  <template v-slot:[`item.CREATE_DATE`]="{ item }">
                    {{ thaiFormattedDate(item.CREATE_DATE) }}
                  </template>
                  <template v-slot:[`item.LAST_DATE`]="{ item }">
                    {{ thaiFormattedDate(item.LAST_DATE) }}
                  </template>
                  <template v-slot:[`item.action`]="{ item }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          class="btn-color"
                          fab
                          dark
                          small
                          @click.stop="
                            (dialogView = true),
                              getDataById(item),
                              validate('View');
                          "
                        >
                          <v-icon dark> mdi-qrcode </v-icon>
                        </v-btn>
                      </template>
                      <span>เปิด Qr code</span>
                    </v-tooltip>
                    <!-- <v-btn
                      class="btn-color"
                      fab
                      small
                      @click.stop="
                        ;(dialogEdit = true),
                          getDataById(item),
                          validate('UPDATE')
                      "
                    >
                      <v-icon dark> mdi-tools </v-icon>
                    </v-btn> -->
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          color="red"
                          dark
                          fab
                          small
                          @click.stop="
                            (dialogDelete = true), getDataById(item);
                          "
                        >
                          <v-icon> mdi-delete </v-icon>
                        </v-btn>
                      </template>
                      <span>ลบข้อมูล</span>
                    </v-tooltip>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
            <div v-if="!dataReady" class="text-center">
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </div>
          </v-col>
          <!-- end data table -->
        </v-row>
      </div>
    </v-main>
  </div>
</template>
<script>
import { QrcodeStream } from 'vue-qrcode-reader'
import VuetifyMoney from '../VuetifyMoney.vue'
import axios from 'axios' // api
import adminLeftMenu from '../Sidebar.vue' // เมนู
import QrcodeVue from 'qrcode.vue'

export default {
  components: {
    'left-menu-admin': adminLeftMenu,
    VuetifyMoney,
    QrcodeVue,
    QrcodeStream
  },
  data () {
    return {
      PK: '',
      path: '/packageQRcode/', // Path Model
      returnLink: '/Master/PackageQRcode',
      // Menu Config
      breadcrumbs: [
        {
          text: 'Home',
          disabled: false,
          href: '/Core/Home'
        },
        {
          text: 'ซื้อแพคเกจ',
          disabled: false,
          href: '/Master/PackageQRcode'
        }
      ],
      options2: {
        locale: 'en-US',
        prefix: '',
        suffix: '',
        length: 9,
        precision: 0
      },
      // End Menu Config
      dataReady: true,
      dataShowQR: false,
      size: 180, // QR Code
      canvas: true,
      dateTime: '', // Generate DateTime
      date: new Date().toISOString().substr(0, 10),
      // Dialog Config ADD EDIT DELETE IMPORT
      dialogAdd: false,
      dialogEdit: false,
      dialogDelete: false,
      dialogView: false,
      dialogViewAdd: false,
      dailogViewRedeem: false,
      amountOf: null,
      // END Dialog Config ADD EDIT DELETE
      session: this.$session.getAll(),
      // Search All
      searchAll: '',
      searchAll2: '',
      searchAll1: '',
      formView: {
        packageImg: '',
        packageName: '',
        rewardName: '',
        rewardSubName: '',
        rewardPictureUrl: ''
      },
      formAdd: {
        packageId: '',
        chkQRCode: 1,
        token: '',
        liffId: '',
        status: 'waiting',
        CREATE_USER: '',
        LAST_USER: '',
        shopId: '',
        qrCodeURL: '',
        masBranchID: '',
        CREATE_DATE: ''
      },
      formUpdate: {},
      rules: {
        required: value => !!value || 'กรุณากรอก.',
        moreThanZero: value => parseFloat(value) > 0 || 'ต้องมากกว่า 0'
      },
      // End Form Config ADD EDIT
      // Data Table Config
      columns: [
        { text: 'ชื่อแพคเกจ', value: 'packageName' },
        { text: 'จำนวนครั้งที่ใช้ได้', value: 'packageCount' },
        { text: 'ราคาแพคเกจ', value: 'packagePrice' },
        { text: 'คะแนนที่ได้ในแต่ละครั้ง', value: 'packagePoint' },
        { text: 'รายละเอียดของแพคเกจ', value: 'packageDetail' },
        { text: 'วันหมดอายุของแพคเกจ', value: 'packageExpridate' },
        { text: 'สถานะ', value: 'status' },
        { text: 'วันที่สร้าง', value: 'CREATE_DATE' },
        // { text: 'วันที่อัพเดท', value: 'LAST_DATE' },
        { text: 'จัดการ', value: 'action', sortable: false, align: 'center' }
      ],
      dataItem: [],
      dataBranch: [],
      validAdd: true,
      validUpdate: true,
      statusViewRedeem: false,
      alert: true,
      res: [],
      datasession: '',
      filterItem: [],
      Exchange: '',
      // End Data Table Config
      packageId: [],
      chkQRCode: 1,
      loadingAdd: false,
      loadingEdit: false,
      loadingPacka: false,
      branchId: null,
      statusCheckBranch: true,
      mapDataBranch: {}
    }
  },
  async mounted () {
    try {
      if (this.$session.getAll().data !== undefined) {
        if (this.$session.getAll().data.shopId === this.$route.query.shopId) {
          if (!this.$session.exists()) {
            this.$session.start()
            this.$session.set(
              'data',
              JSON.parse(localStorage.getItem('sessionData'))
            )
            // await this.getDataBranch()
            this.chkViewRedeem()
            location.reload()
          } else {
            await this.getDataBranch()
            this.chkViewRedeem()
          }
        } else {
          localStorage.removeItem('data')
          this.$session.destroy()
          this.$session.clear()
          // alert(this.$route.fullPath)
          this.$router.push(
            '/Core/Login?access=KNYW6L9LPgSgWPvMzGUBPhPXH52ZdndSpq4Ez8SXMzGu3tBvfEFCrYKK86usU7FE47VKpuVCqe3YPA2CHsnZXshcsKG7A4ZaEWUW&callBack=' +
            this.$route.fullPath
          )
        }
      // else {
      //   if (this.$route.query.rewardCode) {
      //     this.$router.push(
      //       '/Core/Login?access=KNYW6L9LPgSgWPvMzGUBPhPXH52ZdndSpq4Ez8SXMzGu3tBvfEFCrYKK86usU7FE47VKpuVCqe3YPA2CHsnZXshcsKG7A4ZaEWUW&callBack=' +
      //         this.$route.fullPath
      //     )
      //   } else {
      //     await this.checkQuery()
      //   }
      // }
      } else {
        if (!this.$session.exists()) {
        // alert(this.$route.fullPath)
          this.$router.push(
            '/Core/Login?access=KNYW6L9LPgSgWPvMzGUBPhPXH52ZdndSpq4Ez8SXMzGu3tBvfEFCrYKK86usU7FE47VKpuVCqe3YPA2CHsnZXshcsKG7A4ZaEWUW&callBack=' +
            this.$route.fullPath
          )
        } else {
          localStorage.setItem(
            'sessionData',
            JSON.stringify(this.$session.getAll().data)
          )
          // console.log(this.$route.fullPath)
          this.chkViewRedeem()
        }
      }
      // this.chkViewRedeem()
      this.getPackage()
    } catch (error) {
      console.log('error', error)
    }
  },
  methods: {
    showDecimal (item) {
      console.log('showDecimal', item)
      if (item.split('.')[1] === '0') {
        return item.split('.')[0]
      } else {
        return item
      }
      // console.log('showDecimal', item.split('.').length)
    },
    getDataMonth () {
      let month = this.dataItem
      this.dataItem = []
      for (let i = 0; i < month.length; i++) {
        let d = month[i]
        if (d.packageExpri !== '') {
          d.packageExpridate = d.packageExpri + ' เดือน'
          this.dataItem.push(d)
        } else {
          d.packageExpridate = ''
          this.dataItem.push(d)
        }
      }
    },
    getPackage () {
      this.packageId = []
      axios
        .get(this.DNS_IP + '/package/get?shopId=' + this.session.data.shopId)
        .then(response => {
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            s.value = d.packageId.toString()
            s.text = d.packageName
            d = s
            console.log(d)
            this.packageId.push(d)
          }
          let month = this.dataItem
          this.dataItem = []
          for (let i = 0; i < month.length; i++) {
            let d = month[i]
            if (d.packageExpri !== '') {
              //   console.log('888', d.packageExpri)
              d.packageExpridate = d.packageExpri + ' เดือน'
              this.dataItem.push(d)
            } else {
              d.packageExpridate = ''
              this.dataItem.push(d)
            }
          }
        })
    },
    async getDataBranch () {
      // Clear Data ทุกครั้ง
      this.dataBranch = []
      // console.log('getDataCompany')
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/master_branch/' +
            'get?shopId=' +
            this.$route.query.shopId
        )
        .then(async response => {
          let rs = response.data
          if (response.data.status !== false) {
            response.data.forEach((item) => {
              this.mapDataBranch[item.masBranchID] = item.masBranchName
            })
            // this.branchLoyalty.unshift({'masBranchName': 'ทุกสาขา', 'masBranchID': 'ทุกสาขา'})
          }
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            s.value = d.masBranchID.toString()
            s.text = d.masBranchName
            d = s
            this.dataBranch.push(d)
          }
          if (this.dataBranch.length === 1) {
            this.formAdd.masBranchID = s.value
            console.log('masBranch', this.formAdd.masBranchID)
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch(error => {
          console.log(error)
          this.$router.push('/system/Errorpage?returnLink=' + this.returnLink)
        })
    },
    async chkViewRedeem () {
      try {
        let timeOutQrcodePakage = this.$route.query.tpk
        const decodedBuffer = Buffer.from(timeOutQrcodePakage, 'base64')

        const decodedString = decodedBuffer.toString('utf-8')

        const timestampDecode = parseInt(decodedString)

        console.log('Decoded timestamp:', timestampDecode > Date.now())
        console.log('timeOutQrcodePakage timestamp:', timestampDecode)
        console.log('now timestamp:', Date.now())
        if (timestampDecode > Date.now()) {
          await axios
            .get(
              // eslint-disable-next-line quotes
              this.DNS_IP +
            // '/PackageLog/get?shopId=Ucb91b5fb61ff0c01e6d7d4c5f7962c57&token=59766306db23aed14ad175eeea5115cf&userId=U35b246f2825895f3fdcc09b72d589f92'
            '/PackageLog/get?shopId=' +
            this.$route.query.shopId +
            '&token=' +
            this.$route.query.token +
            '&memberId=' +
            this.$route.query.memberId
            )
            .then(async response => {
              if (response.data.status !== false) {
                this.dailogViewRedeem = true
                this.statusViewRedeem = true
                console.log('response.data[0]', response.data[0])
                this.formView.packageName = response.data[0].packageName
                this.formView.packageImg = response.data[0].packageImg
                // this.formView.packageId = response.data[0].packageId
                this.formView.packagePoint = response.data[0].packagePoint
                this.formView.amount = response.data[0].amount
                this.formView.balanceAmount = response.data[0].balanceAmount
                this.formView.nameCustomer = response.data[0].nameCustomer
                this.formView.picture = response.data[0].picture
                this.formView.memberId = response.data[0].memberId
                this.formView.name = response.data[0].name
                if (this.$route.query.shopId === 'U57de59022f079434e724afc24dd8b50a' || this.$route.query.shopId === 'U46b17db406ee6976c058cb98486957c4' || this.$route.query.shopId === 'U84bee5c35d25a597a87e85e0b3029330' || this.$route.query.shopId === 'U4581148094e2790fedc0cc1fa2ef755c') {
                  this.formView.useInBranch = response.data[0].useInBranch
                  if (response.data[0].useInBranch && response.data[0].useInBranch !== '' && response.data[0].useInBranch !== 'None' && response.data[0].useInBranch !== '[]' && response.data[0].useInBranch !== null) {
                    let useInBranchList = JSON.parse(response.data[0].useInBranch)
                    console.log('useInBranchList', useInBranchList)
                    console.log('useInBranchList', typeof parseInt(this.$session.getAll().data.masBranchID))
                    const found = useInBranchList.find((element) => element === parseInt(this.$session.getAll().data.masBranchID))
                    console.log('found', found)
                    if (found) {
                      this.statusCheckBranch = true
                    } else {
                      this.statusCheckBranch = false
                      this.formView.useInBranch = JSON.parse(this.formView.useInBranch)
                      this.formView.useInBranch.forEach((item, index) => {
                        this.formView.useInBranch[index] = this.mapDataBranch[item]
                      })
                    }
                  }
                }
                // this.formView.currentPoint = response.data[0].currentPoint
                // this.formView.levelName = response.data[0].levelName
              } else {
                this.dailogViewRedeem = true
                this.statusViewRedeem = false
              }
            })
          // eslint-disable-next-line handle-callback-err
            .catch(error => {
              console.log(error)
              this.$router.push('/system/Errorpage?returnLink=' + this.returnLink)
            })
        } else {
          this.dailogViewRedeem = true
          this.statusViewRedeem = false
        }
      } catch (error) {
        console.log(';error', error)
      }
    },
    async updateUsePackage () {
      console.log('updateUsePackage')
      this.$swal({
        title: 'ต้องการ หักแพ็กเกจ ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      }).then(async result => {
        this.loadingPacka = true
        try {
          const url1 =
        this.DNS_IP +
        '/use_package/edit?shopId=' +
        this.$session.getAll().data.shopId +
        '&token=' +
        this.$route.query.token
          let config1 = {
            headers: {
              shopId: this.$route.query.shopId,
              memberId: this.$route.query.memberId
            }
          }
          let dt1 = {
            token: this.$route.query.token,
            shopId: this.$route.query.shopId,
            brancId: this.$session.getAll().data.masBranchID,
            user: this.$session.getAll().data.userEmail,
            employeeId: this.$session.getAll().data.userId
          }
          if (this.amountOf) {
            if (this.amountOf.includes('.')) {
              dt1.amountOf = parseFloat(this.amountOf)
            } else {
              dt1.amountOf = parseInt(this.amountOf)
            }
          }
          await axios.post(url1, dt1, config1).then(async response => {
            if (response.data.status === true) {
              // this.loadingPacka = false
              this.$swal({
                title: 'เรียบร้อย',
                type: 'success',
                showCancelButton: false,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#b3b1ab',
                confirmButtonText: 'ตกลง'
              })
                .then(async result => {
                  console.log(result)
                  // this.$swal('เรียบร้อย', 'แก้ไขข้อมูล เรียบร้อย', 'success')
                  this.$router.push('/Reports/reportPackage')
                  console.log('this.session.data.shopId', this.$session.getAll().shopId)
                  this.getPackage()
                })
              // eslint-disable-next-line handle-callback-err
                .catch(error => {
                  console.log(error)
                  // this.$router.push('/Tool/CollectQRCode')
                  // location.reload()
                  // this.dataReady = true
                })
            } else {
              this.$swal('ผิดพลาด', response.data.message, 'error')
              this.$router.push('/Reports/reportPackage')
              location.reload()
            }
          })
        } catch (error) {
          console.log('error', error)
        }
      })
    },
    closeViewRedeem () {
      this.$router.push('/Reports/reportPackage')
      // location.reload()
    },
    validate (Action) {
      switch (Action) {
        case 'ADD':
          this.$nextTick(() => {
            let self = this
            self.$refs.form_add.validate()
          })
          break
        case 'UPDATE':
          this.$nextTick(() => {
            let self = this
            self.$refs.form_update.validate()
          })
          break

        default:
          break
      }
    },
    async searchDataAll () {
      //
      //
      // สำหรับ ค้นหาแบบ LIKE Search
      // ต้องระบุ Field ที่จะส่งไปให้ตรงกับ Model
      //
      var search =
        '?id=' +
        this.searchAll +
        '&productExchangeRateId=' +
        this.searchAll +
        '&amount=' +
        this.searchAll
      this.dataReady = false
      this.searchDataAllGlobal(this.DNS_IP, this.path, search, this.returnLink)
      console.log('search', search)
    },
    async getDataById (item) {
      this.dataReady = false
      await this.getDataByIdGlobal(
        this.DNS_IP,
        this.path,
        'packageQRcodeId',
        item.packageQRcodeId,
        this.returnLink
      )
    },
    async addData () {
      console.log('this.formAdd.Token', this.formAdd.Token)
      this.dataReady = false
      this.dataShowQR = false
      this.$swal({
        title: 'ต้องการสร้างQR CODE ให้ลูกค้าใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async result => {
          this.loadingAdd = true
          this.formAdd.CREATE_USER = this.session.data.userName
          this.formAdd.LAST_USER = this.session.data.userName
          this.formAdd.liffId = process.env.VUE_APP_LIFF_ID
          this.formAdd.shopId = this.$session.getAll().data.shopId
          this.formAdd.qrCodeURL = `https://liff.line.me/${process.env.VUE_APP_LIFF_ID}/packageQRcode?shopId=${this.formAdd.shopId}&packageToken=${this.formAdd.Token}`
          // console.log('this.formAdd.qrCodeURL', this.formAdd.qrCodeURL)
          delete this.formAdd['CREATE_DATE']
          console.log('formAdd', this.formAdd)
          await axios
            .post(this.DNS_IP + this.path + 'add', this.formAdd)
            .then(async response => {
              console.log('addDataGlobal DNS_IP + PATH + "add"', response)
              await axios
                .get(
                  this.DNS_IP +
                    '/packageQRcode/get?shopId=' +
                    this.session.data.shopId +
                    '&token=' +
                    response.data.token
                )
                .then(response => {
                  let res = response.data[0]
                  console.log('res', res)
                  Object.assign(this.formUpdate, res)
                  console.log('assign', Object.assign(this.formUpdate, res))
                })
              this.$swal('เรียบร้อย', 'เพิ่มข้อมูล เรียบร้อย', 'success')
              this.formAdd.CREATE_DATE = new Date().toISOString().substr(0, 10)
              this.dialogViewAdd = true
              this.loadingAdd = false
            })
            .catch(error => {
              console.log('error function addDataGlobal : ', error)
              this.$router.push(
                '/system/Errorpage?returnLink=' + this.returnLink
              )
              this.dataReady = true
            })
        })
        .catch(error => {
          console.log('error function addData : ', error)
          this.dataReady = true
        })
    },
    async editData () {
      this.dataReady = false

      this.$swal({
        title: 'ต้องการ แก้ไขข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async result => {
          this.loadingEdit = true
          this.formUpdate.LAST_USER = this.session.data.userName
          var ID = this.formUpdate.packageQRcodeId
          delete this.formUpdate['packageQRcodeId']
          delete this.formUpdate['LAST_DATE']
          delete this.formUpdate['CREATE_DATE']
          delete this.formUpdate['CREATE_USER']
          await axios
            .post(this.DNS_IP + this.path + 'edit/' + ID, this.formUpdate)
            .then(async response => {
              this.$swal('เรียบร้อย', 'แก้ไขข้อมูล เรียบร้อย', 'success')
              this.dialogEdit = false
              await this.getDataGlobal(
                this.DNS_IP,
                this.path,
                this.session.data.shopId + '&status=waiting',
                this.returnLink
              )
              this.clearData()
            })
            .catch(error => {
              this.dataReady = true
              console.log('error function editDataGlobal : ', error)
              this.$router.push(
                '/system/Errorpage?returnLink=' + this.returnLink
              )
            })
          this.loadingEdit = false
        })
        .catch(error => {
          this.dataReady = true
          console.log('error function editDataGlobal : ', error)
        })
    },
    async deleteData () {
      this.formUpdate.LAST_USER = this.session.data.userName
      console.log('formupdate', this.formUpdate.LAST_USER)
      console.log('DELETE PK : ', this.formUpdate.packageQRcodeId)
      this.dataReady = false
      this.deleteDataGlobal(
        this.DNS_IP,
        this.path,
        this.formUpdate.packageQRcodeId,
        this.session.data.shopId,
        '&status=waiting',
        this.returnLink
      )
    },
    async clearData () {
      this.formAdd.packageId = ''
      this.formAdd.masBranchID = ''
    },
    async clearDataUpdate () {
      this.formUpdate.id = ''
      this.formUpdate.productExchangeRateId = ''
      this.formUpdate.amount = 0
      this.formUpdate.point = 0
      this.formUpdate.token = ''
      this.formUpdate.status = ''
      this.formUpdate.statusMemberCard = 'collect'
      this.formUpdate.CREATE_USER = ''
      this.formUpdate.LAST_USER = ''
      this.formUpdate.shopId = ''
      this.formUpdate.qrCodeURL = ''
      this.formUpdate.CREATE_DATE = ''
      this.formUpdate.LAST_DATE = ''
      this.formUpdate.branchName = ''
      this.formUpdate.masBranchID = ''
    },
    clearSearch () {
      this.search.masBranchID = ''
      this.search.amount = ''
    }
  }
}
</script>
<style scoped>
.shopname {
  font-size: 13px;
}
.description {
  font-size: 14px;
}
.summary {
  font-size: 20px;
}
.point {
  font-size: 100px;
}
.fullscreen {
  position: fixed;
  z-index: 1000;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
}
.scan-confirmation {
  position: absolute;
  width: 100%;
  height: 100%;

  background-color: rgba(255, 255, 255, 0.8);
  /* margin: auto auto;
    display: block; */
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  /* vertical-align: middle; */
}
#subtext {
  color: #173053;
  font-size: 20px !important;
  font-weight: bold;
}
#margit_vector {
  position: absolute;
  left: 42.03%;
  right: 42.75%;
  top: 15%;
  color: #ffa610;
  size: 50px;
}
#text_awesome {
  position: absolute;
  top: 20%;
  font-size: 40px;
  line-height: 23px;
  font-weight: bold;
  color: #173053;
}
#text_a {
  font-weight: bold;
  color: #173053;
  align-items: center;
  text-align: center;
  font-size: 30px !important;
}
#text_b {
  font-weight: bold;
  font-size: 50px !important;
  align-items: center;
  text-align: center;
  color: #ffa000;
}
</style>



// WEBPACK FOOTER //
// src/components/Master/PackageQRcode.vue